import { Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";

function VehicleMarkers({ vehicles = [], activeVehicle }) {
  const map = useMap();

  useEffect(() => {
    if (activeVehicle) {
      map.flyTo(activeVehicle.location.coordinates, 15, {
        animate: true,
      });
    }
  }, [activeVehicle]);

  return vehicles.map((vehicle, idx) => {
    if (!vehicle.location?.coordinates) {
      return null;
    }
    const icon = new L.DivIcon({
      className: "my-div-icon",
      html:
        '<img src="/assets/imgs/bicycle.png" style="width:40px;height:40px;"/>' +
        `<span style="background-color:#000;color:#fff;font-weight:bold;">${vehicle.vehicle_number}</span>`,
    });
    return (
      <Marker icon={icon} key={idx} position={vehicle.location.coordinates}>
        <Popup>
          Vehicle Number <br /> <a>{vehicle.vehicle_number}</a>.
        </Popup>
      </Marker>
    );
  });
}

export default VehicleMarkers;
